export const appEventsApiFactory = ({ callPostApi }) => ({
    sendEventList: events => callPostApi('/app-events', events, {}, true),
});
